"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omit = exports.fastClone = void 0;
// TODO: pull from builder internal utils
var fastClone = function (obj) { return JSON.parse(JSON.stringify(obj)); };
exports.fastClone = fastClone;
var omit = function (obj) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    var newObject = Object.assign({}, obj);
    for (var _a = 0, values_1 = values; _a < values_1.length; _a++) {
        var key = values_1[_a];
        delete newObject[key];
    }
    return newObject;
};
exports.omit = omit;
//# sourceMappingURL=utils.js.map